
<template>
  <div class="main-content">
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"></loading>

    <b-container>
      <b-card  title="Edit Fraud Rule" class="card-icon mb-30 p-16">

        <form action="#" class="form-horizontal "  method="post" v-on:submit.prevent="validateBeforeSubmitRule">
          <b-row>
            <b-col lg="12" md="12" sm="12">
              <div >
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Rule Name</strong></label> <br/>
                      <input type="text" class="form-control" v-model="rule.ruleName" />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Description</strong></label> <br/>
                      <input type="text" class="form-control" v-model="rule.description" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Error Message</strong></label> <br/>
                      <input type="text" class="form-control" v-model="rule.errorMessage" />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Activity Type: </strong></label> <br/>
                      <select class="form-control" v-model="rule.activityType">
                        <option value="ACCRUAL"> Accrual </option>
                        <option value="REDEMPTION"> Redemption </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Status:</strong></label> <br/>
                      <label for="rule-active">
                        <strong><input id="rule-active" type="radio" class="form-check" v-model="rule.status" value="ACTIVE" /> Active </strong>
                      </label>
                      <label class="ml-5" for="rule-inactive">
                        <strong><input id="rule-inactive" type="radio" class="form-check" v-model="rule.status" value="INACTIVE" /> Inactive </strong>
                      </label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Rule Logic: </strong></label> <br/>
                      <select class="form-control" v-model="rule.ruleLogic">
                        <option value="AND"> AND </option>
                        <option value="OR"> OR </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Action Type: </strong></label> <br/>
                      <select class="form-control" v-model="rule.actionType">
                        <option value="FLAG"> Flag </option>
                        <option value="REJECT"> Reject </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Duration (In Days)</strong></label> <br/>
                      <input type="number" class="form-control" v-model="rule.duration" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label><strong>Category: </strong></label> <br/>
                      <select class="form-control" v-model="rule.category">
                        <option value="ALL"> All </option>
                        <option value="OUTLET"> Outlet </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6" v-if="rule.category == 'OUTLET'">
                    <div class="form-group">
                      <label><strong>Outlet: </strong></label> <br/>
                      <select class="form-control" v-model="rule.outletId">
                        <option value="0"> -- Select -- </option>
                        <option :value="outlet.id" v-for="outlet in outlets" :key="outlet.id"> {{ outlet.name }} </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label><strong>Rules</strong></label> <br/>
                    <table class="table table-bordered">
                      <tr>
                        <th>Criteria</th>
                        <th>Operation</th>
                        <th>Value</th>
                        <th>Options</th>
                      </tr>
                      <tr v-for="(ruleItem, index) in rule.rules" :key="index">
                        <td>
                          <select class="form-control" v-model="ruleItem.criteria">
                            <option value=""> -- Select -- </option>
                            <option value="TOTAL_ACCRUAL_AMOUNT">Total Accrual Amount </option>
                            <option value="TOTAL_ACCRUAL_BASE_POINTS">Total Accrual Base Points </option>
                            <option value="TOTAL_ACCRUAL_BONUS_POINTS">Total Accrual Bonus Points </option>
                            <option value="TOTAL_ACCRUAL_POINTS">Total Accrual Points </option>
                            <option value="TOTAL_ACCRUAL_TRANSACTION_COUNT">Total Accrual Transaction Count </option>
                            <option value="TOTAL_REDEMPTION_AMOUNT">Total Redemption Amount </option>
                            <option value="TOTAL_REDEMPTION_TRANSACTION_COUNT">Total Redemption Transaction Count </option>
                          </select>
                        </td>
                        <td>
                          <select class="form-control" v-model="ruleItem.equality">
                            <option value=""> -- Select -- </option>
                            <option value="EQUAL"> Equal </option>
                            <option value="GREATER_THAN">Greater Than </option>
                            <option value="GREATER_THAN_OR_EQUAL">Greater than or equal </option>
                            <option value="LESS_THAN">Less than </option>
                            <option value="LESS_THAN_OR_EQUAL">Less than or equal </option>
                          </select>
                        </td>
                        <td>
                          <input type="number" class="form-control" v-model="ruleItem.value">
                        </td>
                        <td>
                          <b-button
                              type="button"
                              @click="removeRule(index)"
                              variant="danger"
                              class="btn-icon"
                          >
                            <feather-icon icon="ArchiveIcon" />
                          </b-button>
                        </td>
                      </tr>
                    </table>

                    <br/>

                    <button type="button" @click="addRule" class="btn btn-warning btn-sm float-right">Add Rule</button>
                  </div>
                </div>
              </div>

              <div class="mt-2 mb-2" >
                <hr/>
              </div>
              <div >
                <button class="btn btn-success float-right" type="submit" >Update</button>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-card>
    </b-container>

  </div>
</template>
<script>

  import { mapGetters, mapActions } from "vuex";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css'
  import Multiselect from 'vue-multiselect';
  import vSelect from 'vue-select'
  import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
  import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
  import Button from "@/views/components/button/Button.vue";
  import Table from "@/views/table/bs-table/Table.vue";

export default {
  data() {
    return {
      outletProduct:"",
      selectMode: 'multi',
      days:["MON","TUE","WED","THU","FRI","SAT","SUN"],
      disabled:false,
      isLoading: false,
      fullPage: true,
      outlets:[],
      partners:[],
      products:[],
      outlet_columns:["name"],
      rule:{
        id:0,
        ruleName:"",
        description:"",
        errorMessage:"",
        status:"",
        activityType:"",
        actionType:"",
        ruleLogic:"",
        rules:[],
        duration:1,
        category:"",
        outletId:0
      },
      selectedOutlets:[],
      selectedProducts:[]
    };
  },
  components: {
    Table,
    Button,
    Loading,
    DatePicker,
    Multiselect,
    vSelect
  },
  mounted (){
    this.getOutletsData();
    this.loadFraudRule();
  },
  methods: {
    ...mapActions(["editFraudRule","getFraudRule",'getOutlets']),

    getOutletsData(){
      let self = this;
      this.getOutlets()
          .then(function (outlets) {
            self.outlets = outlets;
          })
          .catch(function (error) {

          })
    },

    loadFraudRule(){
      let self = this;
      const ruleId = this.$route.params.id;

      if(!ruleId){
        this.$bvToast.toast("Invalid fraud rule ID", {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: false
        });
        this.$router.push("/apps/fraudRules");
        return;
      }

      this.isLoading = true;

      this.getFraudRule({id: ruleId})
          .then(function (fraudRule) {
            self.isLoading = false;

            // Map the fraud rule data to the form
            self.rule.id = fraudRule.id;
            self.rule.ruleName = fraudRule.ruleName;
            self.rule.description = fraudRule.description;
            self.rule.errorMessage = fraudRule.errorMessage;
            self.rule.status = fraudRule.status;
            self.rule.activityType = fraudRule.activityType;
            self.rule.actionType = fraudRule.actionType;
            self.rule.ruleLogic = fraudRule.ruleLogic;
            self.rule.duration = fraudRule.duration;
            self.rule.category = fraudRule.category;
            self.rule.outletId = fraudRule.outlet ? fraudRule.outlet.id : 0;

            // Map the rules array
            if(fraudRule.rules && fraudRule.rules.length > 0){
              self.rule.rules = fraudRule.rules.map(r => ({
                value: r.value,
                criteria: r.criteria,
                equality: r.equality
              }));
            }
          })
          .catch(function (error) {
            self.isLoading = false;
            self.$bvToast.toast("Failed to load fraud rule", {
              title: 'Error',
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: false
            });
            self.$router.push("/apps/fraudRules");
          })
    },

    validateBeforeSubmitRule() {
      // Validate basic fields
      if (!this.rule.ruleName || this.rule.ruleName.trim() === "") {
        this.$bvToast.toast("Please enter a rule name", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      if (!this.rule.description || this.rule.description.trim() === "") {
        this.$bvToast.toast("Please enter a description", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      if (!this.rule.errorMessage || this.rule.errorMessage.trim() === "") {
        this.$bvToast.toast("Please enter an error message", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      if (!this.rule.status || this.rule.status === "") {
        this.$bvToast.toast("Please select a status", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      if (!this.rule.activityType || this.rule.activityType === "") {
        this.$bvToast.toast("Please select an activity type", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      if (!this.rule.actionType || this.rule.actionType === "") {
        this.$bvToast.toast("Please select an action type", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      if (!this.rule.ruleLogic || this.rule.ruleLogic === "") {
        this.$bvToast.toast("Please select a rule logic", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      if (!this.rule.duration || this.rule.duration <= 0) {
        this.$bvToast.toast("Please enter a valid duration (greater than 0)", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      if (!this.rule.category || this.rule.category === "") {
        this.$bvToast.toast("Please select a category", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      // Validate outlet selection if category is OUTLET
      if (this.rule.category === "OUTLET" && (!this.rule.outletId || this.rule.outletId === 0)) {
        this.$bvToast.toast("Please select an outlet", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      // Validate rules array
      if (!this.rule.rules || this.rule.rules.length === 0) {
        this.$bvToast.toast("Please add at least one rule", {
          title: 'Validation Error',
          variant: 'warning',
          autoHideDelay: 5000,
          appendToast: false
        });
        return;
      }

      // Validate each rule in the rules array
      for (let i = 0; i < this.rule.rules.length; i++) {
        const ruleItem = this.rule.rules[i];

        if (!ruleItem.criteria || ruleItem.criteria === "") {
          this.$bvToast.toast(`Please select criteria for rule ${i + 1}`, {
            title: 'Validation Error',
            variant: 'warning',
            autoHideDelay: 5000,
            appendToast: false
          });
          return;
        }

        if (!ruleItem.equality || ruleItem.equality === "") {
          this.$bvToast.toast(`Please select operation for rule ${i + 1}`, {
            title: 'Validation Error',
            variant: 'warning',
            autoHideDelay: 5000,
            appendToast: false
          });
          return;
        }

        if (!ruleItem.value || ruleItem.value <= 0) {
          this.$bvToast.toast(`Please enter a valid value (greater than 0) for rule ${i + 1}`, {
            title: 'Validation Error',
            variant: 'warning',
            autoHideDelay: 5000,
            appendToast: false
          });
          return;
        }
      }

      // All validations passed, proceed to save
      this.saveRule();
    },
    addRule(){
      this.rule.rules.push({
        value:0,
        criteria:"",
        equality:""
      });
    },
    removeRule(index) {
      this.rule.rules.splice(index,1)
    },

    saveRule() {
      let self = this;

      console.log(this.rule);

      this.isLoading = true;

      this.editFraudRule(this.rule).then(() => {
        self.isLoading = false;

        self.$bvToast.toast("Fraud rule updated successfully!", {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 5000,
          appendToast: false
        });

        this.$router.push("/apps/fraudRules");
      })
          .catch(error => {
            self.isLoading = false;

            // Provide detailed error message
            let errorMessage = "Failed to update fraud rule. Please try again.";

            if (error && error.message) {
              errorMessage = error.message;
            } else if (error && error.response) {
              if (error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
              } else if (error.response.status === 401) {
                errorMessage = "Session expired. Please login again.";
                setTimeout(() => {
                  location.replace("/app/sessions/signIn");
                }, 2000);
              } else if (error.response.status === 403) {
                errorMessage = "You don't have permission to perform this action.";
              } else if (error.response.status === 500) {
                errorMessage = "Server error. Please contact administrator.";
              } else {
                errorMessage = `Error: ${error.response.statusText || 'Unknown error'}`;
              }
            }

            self.$bvToast.toast(errorMessage, {
              title: 'Error',
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: false
            });

            console.error("Error updating fraud rule:", error);
          })
    }
  },

};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
